import React, { useState, useEffect } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Consulta } from '../../services/mockData';
import './Financial.css';

interface ConsultationValueModalProps {
  isOpen: boolean;
  onClose: () => void;
  consulta: Consulta | null;
  onSave: (data: {
    valor?: number;
    pago?: boolean;
    dataPagamento?: string;
  }) => void;
}

export const ConsultationValueModal: React.FC<ConsultationValueModalProps> = ({
  isOpen,
  onClose,
  consulta,
  onSave,
}) => {
  const [valor, setValor] = useState('');
  const [pago, setPago] = useState(false);
  const [dataPagamento, setDataPagamento] = useState('');

  useEffect(() => {
    if (consulta) {
      setValor(consulta.valor ? consulta.valor.toFixed(2).replace('.', ',') : '');
      setPago(consulta.pago || false);
      setDataPagamento(consulta.dataPagamento ? consulta.dataPagamento.split('T')[0] : '');
    } else {
      setValor('');
      setPago(false);
      setDataPagamento('');
    }
  }, [consulta, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const valorNum = valor ? parseFloat(valor.replace(',', '.')) : undefined;

    onSave({
      valor: valorNum,
      pago,
      dataPagamento: pago && dataPagamento ? new Date(dataPagamento).toISOString() : undefined,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={consulta ? 'Editar Valor da Consulta' : 'Adicionar Valor da Consulta'}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit}>
            Salvar
          </Button>
        </>
      }
    >
      {consulta && (
        <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: 'var(--page-surface-hover)', borderRadius: '8px' }}>
          <p style={{ margin: 0, fontSize: '14px' }}>
            <strong>Paciente:</strong> {consulta.pacienteNome}
          </p>
          <p style={{ margin: '4px 0 0 0', fontSize: '14px' }}>
            <strong>Data:</strong> {new Date(consulta.dataIso).toLocaleDateString('pt-BR')}
          </p>
        </div>
      )}

      <form className="ns-form" onSubmit={handleSubmit}>
        <label className="ns-field">
          <span>Valor da Consulta (R$)</span>
          <input
            className="ns-input"
            type="text"
            value={valor}
            onChange={(e) => {
              const value = e.target.value.replace(/[^\d,.-]/g, '');
              setValor(value);
            }}
            placeholder="0,00"
          />
        </label>

        <label className="ns-field">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={pago}
              onChange={(e) => setPago(e.target.checked)}
            />
            <span>Marcar como pago</span>
          </div>
        </label>

        {pago && (
          <label className="ns-field">
            <span>Data de Pagamento</span>
            <input
              className="ns-input"
              type="date"
              value={dataPagamento}
              onChange={(e) => setDataPagamento(e.target.value)}
            />
          </label>
        )}
      </form>
    </Modal>
  );
};

